import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";


// Create styles
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 20,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    width: "100%",
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Oswald",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: "Oswald",
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: "right",
    color: "black",
  },
  header2: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "left",
    color: "black",
    width:'20%'
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  cardContainer: {
    border: '1pt solid black',
    borderRadius: 5,
    marginBottom: 20,
    width:'30%',

  },
  cardTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    border: '1pt solid black',
    padding:'5px'
  },
  cardContent: {
    fontSize: 12,
    padding:'5px'
  },
});

// Create Document Component
const PDFRender = (props) => {

  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.container}>
          <Text style={styles.header2} fixed>
            {props.user.propertName}
          </Text>
          <Text style={styles.header} fixed>
            Invoice
          </Text>
        </View>
        <View style={styles.cardContainer}>
          <Text style={styles.cardTitle}>Bill to</Text>
          <Text style={styles.cardContent}>
            {props.user.propertName}

          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.text}>
            Es, pues, de saber, que este sobredicho hidalgo, los ratos que
            estaba ocioso (que eran los más del año) se daba a leer libros de
            caballerías con tanta afición y gusto, que olvidó casi de todo punto
            el ejercicio de la caza, y aun la administración de su hacienda; y
            llegó a tanto su curiosidad y desatino en esto, que vendió muchas
            hanegas de tierra de sembradura, para comprar libros de caballerías
            en que leer; y así llevó a su casa todos cuantos pudo haber dellos;
            y de todos ningunos le parecían tan bien como los que compuso el
            famoso Feliciano de Silva: porque la claridad de su prosa, y
            aquellas intrincadas razones suyas, le parecían de perlas; y más
            cuando llegaba a leer aquellos requiebros y cartas de desafío, donde
            en muchas partes hallaba escrito: la razón de la sinrazón que a mi
            razón se hace, de tal manera mi razón enflaquece, que con razón me
            quejo de la vuestra fermosura, y también cuando leía: los altos
            cielos que de vuestra divinidad divinamente con las estrellas se
            fortifican, y os hacen merecedora del merecimiento que merece la
            vuestra grandeza.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PDFRender;
